import localSave from '@utils/local-save'

const KEY = 'premiumFunnelOrigin'

// Session-scoped like the post-auth redirect stash: the funnel starts and
// dissolves inside one tab session; persisting it would let a stale origin
// hijack a much later funnel exit.
const STORAGE = 'sessionStorage'

export default {
    // Remember the page the visitor was on when the premium funnel started.
    set(path) {
        localSave.save(KEY, path, STORAGE)
    },

    // Return the remembered origin (or null) and clear it, so it is honored
    // exactly once.
    consume() {
        const origin = localSave.get(KEY, STORAGE)
        if (origin) localSave.delete(KEY, STORAGE)
        return origin || null
    },

    // Forget the origin without navigating anywhere.
    clear() {
        localSave.delete(KEY, STORAGE)
    },
}
